import React, { useMemo } from "react";
import { inspectFrameHex } from "../protocol/frameProtocol";
import "./OperationalViews.css";

export default function FrameInspector({ hex, direction = "TRAMA", label = "", defaultOpen = false }) {
  const inspection = useMemo(() => inspectFrameHex(hex), [hex]);
  if (!hex) return null;

  return (
    <details className={`frame-inspector ${inspection.valid ? "is-valid" : "is-invalid"}`} open={defaultOpen}>
      <summary>
        <span className={`frame-direction is-${String(direction).toLowerCase()}`}>{direction}</span>
        <strong>{label || inspection.parsed?.commandName || "Trama"}</strong>
        <code>{inspection.cleanHex}</code>
        <span className="frame-crc-state">
          {inspection.crcValid ? "CRC correcto" : "CRC/longitud inválidos"}
        </span>
      </summary>
      {inspection.error && <p className="frame-inspector-error">{inspection.error}</p>}
      <div className="frame-byte-table-wrap">
        <table className="frame-byte-table">
          <thead>
            <tr><th>Byte(s)</th><th>Campo</th><th>HEX</th><th>Significado</th></tr>
          </thead>
          <tbody>
            {inspection.fields.map((item, index) => (
              <tr key={`${item.offset}-${item.name}-${index}`}>
                <td>{item.offset}</td>
                <td>{item.name}</td>
                <td><code>{item.value}</code></td>
                <td>{item.meaning}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="frame-inspector-note">
        Se transmite en binario exactamente en este orden; no se agregan caracteres CR/LF al final.
      </p>
    </details>
  );
}
